import { createFileRoute } from '@tanstack/react-router';

import { OverviewPage } from '@/features/(insight)/overview/overview-page';

export const Route = createFileRoute('/workspace/$workspaceId/insight/overview')({
  component: RouteComponent,
});

function RouteComponent() {
  return <OverviewPage />;
}
